/*
 * Gueltiger Bereich einer Verlaufsreihe (TrendSeries.validMin/validMax).
 * Werte ausserhalb werden zur Luecke, statt als Spitze die Skala zu sprengen.
 * Anlass: EWP bei Kurt Sickinger (22.10.2026), dort standen aus der Zeit mit
 * zwei Modbus-Mastern Werte wie -281,6 und 90 im Vorlauf-Verlauf; ein Fuehler
 * ohne Anschluss meldet -999,9. Die Historie selbst bleibt unangetastet.
 */

export interface RangeLimits {
  validMin?: number | null;
  validMax?: number | null;
}

/** Wert innerhalb der Grenzen, sonst null (Luecke). Ohne Grenzen unveraendert. */
export function withinRange(v: number | null, limits: RangeLimits): number | null {
  if (v === null || !Number.isFinite(v)) return null;
  if (limits.validMin != null && v < limits.validMin) return null;
  if (limits.validMax != null && v > limits.validMax) return null;
  return v;
}
